import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import axios from 'axios';
import { Button, InputLabel, Select, MenuItem } from '@material-ui/core';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

import EnhancedTableHead, {
  Transition,
  getComparator,
  stableSort,
} from '../../components/Common/EnhancedTableHead';
import { Delete, Edit, Visibility } from '@material-ui/icons';
import AddYorubaWordDialog from './AddYorubaWordDialog';
import DeleteDailog from '../../components/Common/DeleteDailog';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import { baseUrl, languageId } from '../../helpers/EncryptionHelper';
import LoadIndicator from '../../components/Common/LoadIndicator';
import SearchBar from '../../components/Common/Search';

const headCells = [
  {
    id: 'yoruba_word_name',
    numeric: false,
    disablePadding: false,
    label: 'Yoruba Word Name',
  },
  {
    id: 'actions',
    numeric: false,
    disablePadding: false,
    label: 'Actions',
    align: 'center',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(3),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

// process.env.REACT_APP_SERVER_URL + process.env.REACT_APP_BACKEND_ROUTE;

export default function CustomTableYorubaWord() {
  const classes = useStyles();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('calories');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [openDailog, setOpenDailog] = useState(false);
  const [openDeleteDailog, setOpenDeleteDailog] = useState(false);
  const [selectedYorubaWord, setselectedYorubaWord] = useState(false);
  const [editYorubaWord, setEditYorubaWord] = useState(false);
  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const ITEMS_PER_PAGE = 10;
  const [showLoader, setShowLoader] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchType, setSearchType] = useState('starts');

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleClose = () => {
    setOpenDailog(false);
  };
  function handleCloseDeleteDailog() {
    setselectedYorubaWord();
    setOpenDeleteDailog(false);
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    // setOffset((s) => s + limit)
  };
  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(1); // Reset pagination when searching
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setCurrentPage(1);
    setLimit(parseInt(event.target.value, 10));
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const handleDelete = async (id) => {
    axios
      .delete(baseUrl + `/word/remove/${id}`)
      .then((res) => {
        if (res && res.data.status === 200) {
          handleCloseDeleteDailog();
          toastr.success('Yoruba Word Deleted Successfully', 'Success');

          fetchData(0, ITEMS_PER_PAGE);
          setCurrentPage(1);
        }
      })
      .catch((err) => {
        toastr.error(`Yoruba Word removal Failed`, 'Error!');
      });
  };

  const handleCloseAndRefresh = () => {
    setOpenDailog(false);
    setSelected([]);
    setTimeout(() => {
      fetchData(0, ITEMS_PER_PAGE);
      setCurrentPage(1);
    }, 200);
  };

  const fetchData = async (pageIndex, pageSize) => {
    axios
      .get(baseUrl + `/word/all?offset=${pageIndex}&limit=${pageSize}&search=${searchTerm}&type=${searchType}&language=${languageId}`)
      .then((res) => {
        if (res && res.data.status === 200) {
          setRows(res.data.data.list);
          setTotalCount(parseInt(res.data.data?.totalCount));
          setShowLoader(false);
        }
      })
      .catch((err) => {
        console.log('error');
        setShowLoader(false);
      });
  };

  // useEffect(() => {
  //   fetchData(offset, limit);
  // }, [limit, offset]);
  const ITEMS_PER_PAGE_VAL = ITEMS_PER_PAGE;

  useEffect(() => {
    fetchData((currentPage - 1) * ITEMS_PER_PAGE_VAL, ITEMS_PER_PAGE_VAL);
  }, [searchTerm, currentPage, searchType]);

  const handleChange = (event, value) => {
    setCurrentPage(value);
  };
  const totalPages = Math.ceil(totalCount / ITEMS_PER_PAGE);
  const handleSearchChange = (event) => {
    setSearchType(event.target.value);
  };
  return (
    <div className={classes.root}>
      <Button
        style={{
          backgroundColor: '#257b59',
          color: 'white',
          padding: 10,
          alignSelf: 'flex-end',
          marginBottom: 20,
        }}
        onClick={() => {
          setselectedYorubaWord();
          setOpenDailog(true);
        }}
      >
        Add YorubaWord
      </Button>
      <Paper className={classes.paper}>
        {showLoader ? (
          <LoadIndicator />
        ) : (
          <>
            <InputLabel id="demo-simple-select-label">Search Type</InputLabel>
            <Select style={{ paddingBottom: '10px' }}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={searchType}
              label="Type"
              onChange={handleSearchChange}
            >
              <MenuItem value={'starts'}>Starts with</MenuItem>
              <MenuItem value={'contains'}>Contains</MenuItem>
              <MenuItem value={'match'}>Exact Matches with</MenuItem>
            </Select>
            <SearchBar value={searchTerm} onSearch={handleSearch} />
            {/* <CustomSearchBar
              setRows={setRows}
              keysToSearch={['yoruba_word_name']}
            /> */}
            <TableContainer>
              <Table
                className={classes.table}
                aria-labelledby='tableTitle'
                size={dense ? 'small' : 'medium'}
                aria-label='enhanced table'
              >
                <EnhancedTableHead
                  classes={classes}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={rows.length}
                  headCells={headCells}
                />
                <TableBody>
                  {rows.map((row, index) => {
                    return (
                      <TableRow hover tabIndex={-1} key={index}>
                        <TableCell align='left'>
                          {row.yoruba_word_name || row.wordName}
                          {row.phonemic_transcription && (
                            <span style={{ color: '#888', marginLeft: '8px', fontSize: '0.9em' }}>
                              ({row.phonemic_transcription})
                            </span>
                          )}
                        </TableCell>
                        <TableCell width={'30%'} align='center'>
                          <IconButton
                            variant='contained'
                            style={{ color: '#ddd' }}
                            onClick={() => {
                              setselectedYorubaWord(row);
                              setOpenDailog(true);
                            }}
                          >
                            <Visibility />
                          </IconButton>
                          <IconButton
                            variant='contained'
                            style={{ color: '#ddd' }}
                            onClick={() => {
                              setEditYorubaWord(true);
                              setselectedYorubaWord(row);
                              setOpenDailog(true);
                            }}
                          >
                            <Edit />
                          </IconButton>
                          <IconButton
                            variant='contained'
                            style={{ color: '#ddd' }}
                            onClick={() => {
                              setOpenDeleteDailog(true);
                              setselectedYorubaWord(row);
                            }}
                          >
                            <Delete />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            {/* <TablePagination
              rowsPerPageOptions={[50, 100, 200]}
              component='div'
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            /> */}
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Stack spacing={2}>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={handleChange}
                  color="primary"
                  variant="outlined"
                  shape="rounded"
                />
              </Stack>
            </div>
          </>
        )}
      </Paper>
      <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label='Dense padding'
      />

      {openDailog && (
        <AddYorubaWordDialog
          data={selectedYorubaWord}
          visible={openDailog}
          handleClose={handleClose}
          Transition={Transition}
          editYorubaWord={editYorubaWord}
        />
      )}
      {openDeleteDailog && (
        <DeleteDailog
          data={selectedYorubaWord}
          visible={openDeleteDailog}
          handleClose={handleCloseDeleteDailog}
          Transition={Transition}
          dialogTitle={() => (
            <div className='mt-3'>
              Do you want to delete this WordType :{' '}
              <strong>{selectedYorubaWord?.yoruba_word_name || 'NA'}</strong>
            </div>
          )}
          handleDeleteClicked={(data) =>
            handleDelete(data._id || data.id || data.yoruba_word_id)
          }
        />
      )}
    </div>
  );
}
